<template>
    <div>
        <div class="form_contacts">
            <img src="../assets/imgs/personal/Icon.png" class="icona" style="width: 150px;" alt="">
            <div class="title">CONTACTS</div>
            <p><a class="link" href="https://www.instagram.com/matteortili/?fbclid=IwAR1bOPYmlJKpVzYEG6G0zvsBuoX3LShgQvgvzGmsz0Cn0-X3dy0slPu0vkA"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" size="lg"/> MATTEORTILI</a></p>
            <p><a class="link" href="https://www.instagram.com/matteortiliart/"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" size="lg"/> MATTEORTILIART</a></p>
            <p><a class="link" href="https://www.facebook.com/matteowm.ortili/timeline?lst=1178044414%3A100000494969261%3A1570555429"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }" size="lg"/> MATTEORTILI</a></p>
            <p><a class="link" href="mailto:matteo.ortili97@gmail.com"><font-awesome-icon icon="envelope" size="lg"/> MATTEO.ORTILI97@GMAIL.COM</a></p>
            <p><a class="link" href="tel:+393314334213"><font-awesome-icon :icon="{ prefix: 'fab', iconName: 'whatsapp' }" size="lg"/> 331 4334213</a></p>
        
        
        </div>

        <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2034.256708115805!2d10.5200430503371!3d43.8584520879297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12d583dd0bda28f1%3A0xae0afb66b6fa2ef8!2sVia%20dell&#39;Acquacalda%2C%2083%2C%2055100%20Lucca%20LU!5e0!3m2!1sit!2sit!4v1597343555383!5m2!1sit!2sit" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>

    
    </div>
</template>

<script>
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faFacebook,faInstagram,faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret)
library.add(faEnvelope)
library.add(faFacebook)
library.add(faInstagram)
library.add(faWhatsapp)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

export default {
    name: 'MOAContacts',
    metaInfo() {
        return {
            title: 'MOA - Contacts',
            meta: [
                {name: 'title', content:'Matteo Ortili Art - Contacts'},
                {name: 'description', content: 'Contacts info of Matteo Ortili'},
                {property: 'og:title', content: "Matteo Ortili Art - Contacts"},
                {property: 'og:site_name', content: 'MatteOrtiliArt (MOA)'},
                {property: 'og:type', content: 'website'},
                {property: 'og:url', content: 'https://www.matteortili.com/#/contacts'},
                {property: 'og:description', content: 'Contacts info of Matteo Ortili'},
                {property: 'og:image:secure_url', itemprop: 'image', content: 'https://www.matteortili.com/imgs/link_img.jpg'},
            ]
        }
    }
}
</script>

<style scoped>
.form_contacts{
    width: 100%;
    height: 100vh;
    background-image: url("../assets/imgs/bg/bg1.jpg");
    color: white!important;
    font-family: 'Roboto', sans-serif;
    text-align: center;
    
    
}

.map {
    -webkit-filter: grayscale(100%);
       -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
         -o-filter: grayscale(100%);
            filter: grayscale(100%);
}

.title{
    text-align: center;
    padding-top: 10px;
    letter-spacing: 3vw;
}

@media screen and (min-width: 705px) {
    .title{
        font-size: 52pt;
    }
  }
 
  @media screen and (max-width: 704px) {
    .title{
        font-size: 9vw;
    }
  }

  

.icona{
    padding-top: 215px;
}

.form_contact > p{
    font-size: 12pt;
}

.link{
    color: white;
    font-family: 'Roboto', sans-serif;
    letter-spacing: 2px;
    font-size: 1.2rem;
    font-weight: 300;
}

.link:hover{
    color: rgb(202, 202, 202);
    text-decoration: none;
}
</style>